/* eslint-disable no-param-reassign */
/* eslint-disable no-console */

export default {
  state: {
    left: false,
    leftWidth: 300,
    right: false,
    rightWidth: 540,
    showFilterRuleComposer: false,
    showFilterDialog: false,
    filterRuleComposerDimensions: {},
    showCollabDialog: false
  },
  getters: {},
  actions: {},
  mutations: {
    setLeft(state, payload) {
      state.left = payload;
    },
    setRight(state, payload) {
      state.right = payload;
    },
    setShowFilterRuleComposer(state, payload) {
      state.showFilterRuleComposer = payload;
    },
    setShowFilterDialog(state, payload) {
      state.showFilterDialog = payload;
    },
    setFilterRuleComposerDimensions(state, payload) {
      state.filterRuleComposerDimensions = payload;
    },
    setShowCollabDialog(state, payload) {
      state.showCollabDialog = payload;
    }
  },
  namespaced: true
};
